import React from 'react'
import { ElfsightWidget } from 'react-elfsight-widget';

export const AgeGuard = () => {
    return <ElfsightWidget widgetID="d54058ea-916d-4e5f-9733-5b0a612195a6" />;
}
